export default "__VITE_ASSET__CYzm4HuR__"